import React, { Component } from 'react';
import { Field } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import LineItem from '../../order/line-item';

class Shipment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: this.props.selected && this.props.selected.id,
        };

        this.renderHiddenFieldForShipmentId = this.renderHiddenFieldForShipmentId.bind(this);
        this.onChangeShippingRate = this.onChangeShippingRate.bind(this);
    }

    componentDidMount() {
        this.setShipmentIdInHiddenField(this.props.shipment.id);
    }

    onChangeShippingRate(e) {
        this.setState({
            selected: e.target.value,
        });
    }

    /*
      :DIRTY HACK:
      Redux-form form doesn't support hidden fields. So, we create a hidden field
      and manually trigger its onChange to set the value in redux-form reducer.
    */
    setShipmentIdInHiddenField(value) {
        this.onChangeCallbackForShipmentId(value);
    }

    renderHiddenFieldForShipmentId(field) {
        this.onChangeCallbackForShipmentId = field.input.onChange;
        return <input {...field.input} value={this.props.shipment.id} type="hidden" />;
    }

    render() {
        const {
            shipment, store, hideTitle, details,
        } = this.props;

        const shipmentMarkup = shipment.shipping_rates.map((shippingRate, idx) => {
            const label = `${shippingRate.attributes.name} ( ${shippingRate.attributes.display_cost} )`;
            const isExpress = shippingRate.attributes.name && (shippingRate.attributes.name.includes('Express Shipping') === true || shippingRate.attributes.name.includes('Envío Expedito') === true);

            return (
                <div key={idx} className="checkout-line-item-options">
                    <label>
                        <Field
                            name={`${this.props.fieldNamePrefix}[selected_shipping_rate_id]`}
                            component="input"
                            type="radio"
                            value={`${shippingRate.id}`}
                            checked={this.state.selected === shippingRate.id}
                            onClick={this.onChangeShippingRate}
                            disabled={isExpress}
                        />
                        {/* eslint-disable-next-line max-len */}
                        <span style={{ color: (isExpress) ? '#999' : '#000' }}>
                            {label}
                        </span>
                    </label>
                </div>
            );
        });

        return (
            <div className="checkout-delivery-block" style={{ marginTop: hideTitle ? '1px' : '' }}>
                <div className="checkout-section-title" style={{ paddingTop: '12px', display: hideTitle ? 'none' : 'flex' }}>
                    <FormattedMessage id="shipment" defaultMessage="Shipment to " />
                    <span style={{ marginLeft: 6 }}>{ store && store.name }</span>
                </div>
                <p className="checkout-section-message">
                    { details && (
                        <strong>
                            <span>{details}</span>
                        </strong>
                    )}
                </p>
                <div className="checkout-line-item-options-block">{shipmentMarkup}</div>
                { store && (
                    <div>
                        {this.props.lineItems
                            .filter((item) => item.attributes.store_id === store.id
                                && item.attributes.inventory_unit
                                // eslint-disable-next-line eqeqeq
                                && shipment.id == item.attributes.inventory_unit.shipment_id)
                            .map((lineItem, idx) => (
                                <LineItem lineItem={lineItem} key={idx} />))}
                    </div>
                )}
                <Field name={`${this.props.fieldNamePrefix}[id]`} component={this.renderHiddenFieldForShipmentId} />
            </div>
        );
    }
}

export default Shipment;



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/delivery/shipment.jsx
 **/